export default __webpack_public_path__ + "static/media/pencil.68c2698c.svg";